module.exports = __webpack_public_path__ + "img/IMG_2527-2.b31ea5ed.jpg";